import { createFileRoute } from '@tanstack/react-router';
import { AccountNotifications } from '@uturn/portal/modules/account/pages/notifications';

export const Route = createFileRoute('/_protected/account/notifications')({
	component: AccountNotifications,
});
